import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CATEGORIES, RECURRING, STATUS } from "@/lib/api";
import { Repeat } from "lucide-react";

const Field = ({ label, children }) => <div><Label>{label}</Label>{children}</div>;

export const JobForm = ({ form, setForm, employees, customers, editing, onSubmit }) => {
  const set = (patch) => setForm({ ...form, ...patch });
  const pickCustomer = (v) => {
    if (v === "manual") return set({ customer_id: "", customer_name: "" });
    const c = customers.find((x) => x.id === v);
    set({ customer_id: v, customer_name: c?.name || "", address: form.address || c?.address || "" });
  };
  const pickEmployee = (v) => {
    if (v === "none") return set({ employee_id: "", employee_name: "" });
    set({ employee_id: v, employee_name: employees.find((x) => x.id === v)?.name || "" });
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <Field label="İş Başlığı *">
        <Input required value={form.title} onChange={(e) => set({ title: e.target.value })}
               placeholder="Örn: 3+1 Daire Genel Temizlik" data-testid="job-title-input" />
      </Field>
      <div className="grid grid-cols-2 gap-4">
        <Field label="Kategori *">
          <Select value={form.category} onValueChange={(v) => set({ category: v })}>
            <SelectTrigger data-testid="job-category-select"><SelectValue /></SelectTrigger>
            <SelectContent>{CATEGORIES.map((c) => <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        <Field label="Tarih *">
          <Input type="date" required value={form.date} onChange={(e) => set({ date: e.target.value })} data-testid="job-date-input" />
        </Field>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Field label="Müşteri">
          <Select value={form.customer_id || "manual"} onValueChange={pickCustomer}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="manual">Manuel giriş</SelectItem>
              {customers.map((c) => <SelectItem key={c.id} value={c.id}>{c.name} {c.house_name && `(${c.house_name})`}</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
        <Field label="Müşteri Adı">
          <Input value={form.customer_name} onChange={(e) => set({ customer_name: e.target.value })} data-testid="job-customer-input" />
        </Field>
      </div>
      <Field label="Adres">
        <Textarea rows={2} value={form.address} onChange={(e) => set({ address: e.target.value })} data-testid="job-address-input" />
      </Field>
      <div className="grid grid-cols-2 gap-4">
        <Field label="Çalışan">
          <Select value={form.employee_id || "none"} onValueChange={pickEmployee}>
            <SelectTrigger data-testid="job-assigned-employee-select"><SelectValue placeholder="Seç" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">Atanmadı</SelectItem>
              {employees.map((em) => <SelectItem key={em.id} value={em.id}>{em.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
        <Field label="Durum">
          <Select value={form.status} onValueChange={(v) => set({ status: v })}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>{STATUS.map((s) => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Field label="Fiyat (Müşteriden) ₺ *">
          <Input type="number" step="0.01" required value={form.price} onChange={(e) => set({ price: e.target.value })} data-testid="job-price-input" />
        </Field>
        <Field label="Çalışan Hakedişi ₺">
          <Input type="number" step="0.01" value={form.employee_payment} onChange={(e) => set({ employee_payment: e.target.value })} data-testid="job-employee-payment-input" />
        </Field>
      </div>
      {!editing && (
        <div className="grid grid-cols-2 gap-4 p-3 rounded-lg bg-slate-50 border border-slate-200">
          <div>
            <Label className="flex items-center gap-1"><Repeat className="h-3.5 w-3.5" /> Tekrar</Label>
            <Select value={form.recurring} onValueChange={(v) => set({ recurring: v })}>
              <SelectTrigger data-testid="job-recurring-select"><SelectValue /></SelectTrigger>
              <SelectContent>{RECURRING.map((r) => <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          {form.recurring !== "yok" && (
            <Field label="Kaç kere?">
              <Input type="number" min="1" max="52" value={form.recurring_count} onChange={(e) => set({ recurring_count: e.target.value })} data-testid="job-recurring-count-input" />
            </Field>
          )}
        </div>
      )}
      <Field label="Notlar">
        <Textarea rows={2} value={form.notes} onChange={(e) => set({ notes: e.target.value })} />
      </Field>
      <DialogFooter>
        <Button type="submit" className="bg-emerald-600 hover:bg-emerald-700" data-testid="save-job-button">{editing ? "Güncelle" : "Kaydet"}</Button>
      </DialogFooter>
    </form>
  );
};
